import { ArchiveOffOutlineIcon } from './ArchiveOffOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 6E4F081A-2C98-4B93-B617-F1077839E94E
 * name archive-off-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-off-outline.svg
 * tags
 */
export const BoxOffOutlineIcon = ArchiveOffOutlineIcon;
export default BoxOffOutlineIcon